import React from 'react';
import { motion } from 'framer-motion';
import { SectionTag } from './ui/SectionTag';
import { PlaceholderMockup } from './ui/PlaceholderMockup';
import type { BonoContent } from '../types/content';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
interface BonoItemProps {
  bono: BonoContent;
}
export function BonoItem({
  bono
}: BonoItemProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 16
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.4,
    ease: easeOut
  }} className="flex flex-col overflow-hidden rounded-2xl border border-mp-border bg-mp-card" data-id="element-44" data-mp="1z8in12t3jjwg">
      <div className="p-5 pb-0" data-id="element-45" data-mp="1u8xo2sdxfbjq">
        <PlaceholderMockup label={bono.imageLabel} aspect="aspect-[4/3]" data-id="element-46" data-mp="1ua8vr3aht3g4" />
      </div>
      <div className="flex flex-1 flex-col p-6" data-id="element-47" data-mp="3jnug2ta0ycwn">
        <SectionTag tone="lime" data-id="element-48" data-mp="3jm14r0ogv4ib">{bono.label}</SectionTag>
        <h3 className="mt-4 font-heading text-xl uppercase leading-snug text-mp-white" data-id="element-49" data-mp="3om5qb548epfe">{bono.title}</h3>
        <p className="mt-1 font-heading text-xs uppercase tracking-[0.15em] text-mp-electric" data-id="element-50" data-mp="7v72zxc51guy">{bono.tag}</p>

        <div className="mt-3 space-y-2 text-sm leading-relaxed text-mp-gray" data-id="element-51" data-mp="2wvt5mluf6cq">
          {bono.copy.map((p, idx) => <p key={idx} data-id="element-52" data-mp="gqwixquthj0y" data-mpi={idx}>{p}</p>)}
        </div>

        <p className="mt-4 font-heading text-sm uppercase tracking-wide text-mp-lime" data-id="element-53" data-mp="co9mtdr45bxy">{bono.destacado}</p>

        {bono.note && <p className="mt-4 text-xs leading-relaxed text-mp-gray/80" data-id="element-54" data-mp="3l3jwb6xc1jfr">{bono.note}</p>}
      </div>
    </motion.div>;
}